// extracted by mini-css-extract-plugin
export default {"ac-panel__footer":"ac-panel-footer_ac-panel__footer__T2Z62"};